module.exports = __webpack_public_path__ + "img/Weapon_298.93232d2b.png";